<script setup lang="ts">
import type { Editor } from '@tiptap/vue-3'
import type { PropType } from 'vue'

import clsx from 'clsx'

import { useAiStore } from '@/stores/modal/ai';

const aiStore = useAiStore()

const props = defineProps({
    editor: {
        type: Object as PropType<Editor>,
        required: true
    },
    isDark: {
        type: Boolean,
        required: true
    },
    element: {
        type: Object,
        required: true
    },
    schema: {
        required: true
    }
})

const handleAddTextAi = (prompt: string) => {
    aiStore.generateText(prompt, props.element, props.schema)

    aiStore.reset()
}

const onAddTextAi = () => {
    aiStore.setModel('text')

    aiStore.setIsOpenModal(true)

    aiStore.setAction(($event: any) => handleAddTextAi($event))
}
</script>

<template>
    <button 
        @click="() => onAddTextAi()"
        :class="clsx('action-text-ai', isDark ? 'dark' : 'light')"
    >
        <span class="sr-only">Text AI</span>

        <svg
            class="w-[25px] h-6"
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 25 24"
        >
            <path
                d="M16.2276 1L15.9489 1.59664C15.8027 1.90994 15.5655 2.164 15.2729 2.32066L14.7157 2.61892L15.2728 2.91718C15.5654 3.07382 15.8026 3.32791 15.9489 3.6412L16.2276 4.23784L16.5061 3.6412C16.6524 3.3279 16.8897 3.07384 17.1823 2.91718L17.7393 2.61892L17.1821 2.32066C16.8896 2.16401 16.6524 1.90993 16.5061 1.59664L16.2276 1Z"
                fill="var(--main-color)"
            />
            <path
                d="M5.51185 12.1429L5.23319 12.7395C5.08691 13.0528 4.84975 13.3069 4.55718 13.4635L4 13.7618L4.55705 14.06C4.84963 14.2167 5.08689 14.4708 5.23319 14.7841L5.51185 15.3807L5.79038 14.7841C5.93667 14.4708 6.17395 14.2167 6.46652 14.06L7.02358 13.7618L6.4664 13.4635C6.17382 13.3069 5.93668 13.0528 5.79038 12.7395L5.51185 12.1429Z"
                fill="var(--main-color)"
            />
            <path
                d="M19.7323 7L20.2628 5.86375C20.409 5.55046 20.6463 5.29639 20.9389 5.13973L22 4.57167L20.9389 4.00362C20.6463 3.84697 20.4091 3.59288 20.2628 3.2796L19.7323 2.14335L19.2018 3.2796C19.0555 3.59289 18.8182 3.84696 18.5256 4.00348L17.4645 4.57167L18.5256 5.13987C18.8182 5.29638 19.0555 5.55046 19.2018 5.86375L19.7323 7Z"
                fill="var(--main-color)"
            />
            <path
                d="M16.3231 5.28571H6.51408C6.0369 5.28571 5.64858 5.70525 5.64858 6.22078V8.71429C5.64858 9.22982 6.0369 9.64935 6.51408 9.64935C6.99126 9.64935 7.37958 9.22982 7.37958 8.71429V7.15584H10.5531V17.1299H8.82209C8.34491 17.1299 7.95658 17.5494 7.95658 18.0649C7.95658 18.5805 8.34491 19 8.82209 19H14.0151C14.4923 19 14.8806 18.5805 14.8806 18.0649C14.8806 17.5494 14.4923 17.1299 14.0151 17.1299H12.2841V7.15584H15.4576V8.71429C15.4576 9.22982 15.8459 9.64935 16.3231 9.64935C16.8003 9.64935 17.1886 9.22982 17.1886 8.71429V6.22078C17.1886 5.70525 16.8003 5.28571 16.3231 5.28571Z"
            />
        </svg>
    </button>
</template>

<style scoped>
.action-text-ai.light svg {
    @apply fill-[#060606];
}

.action-text-ai.dark svg {
    @apply fill-[#FAFAFA];
}
</style>
